import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    api.post("/auth/google", { session_id: sessionId })
      .then(({ data }) => { setUser(data); navigate("/", { replace: true }); })
      .catch((e) => { toast.error(formatError(e)); setUser(false); navigate("/login", { replace: true }); });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center" data-testid="auth-callback">
      <span className="rf-mono text-xs tracking-[0.3em] uppercase">Accesso con Google…</span>
    </div>
  );
}
